// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"c1bdb8ce","264":"485d1107","453":"f56a58b9","480":"de7ecdd3","638":"aa49d004","738":"7eba7d97"}[chunkId] + ".chunk.js";
};